<template>
	<div class="picture-wrapper__bundle">
		<ProviderIcon
			v-for="icon in packageIcons.slice(0, 3)"
			:key="icon.iconWide"
			:iconUrl="icon.iconWide"
			:providerShortName="icon.shortName"
			class="icon"
		/>

		<p v-if="packageIcons.length > 3" class="icon extras">+{{ packageIcons.length - 3 }}</p>
	</div>
</template>

<script setup lang="ts">
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

defineProps<{ packageIcons: { iconWide: string; shortName: string; clearName: string }[] }>();
</script>

<style lang="scss" scoped>
.picture-wrapper__bundle {
	display: flex;
	flex-direction: column;

	.icon {
		position: relative;
		margin-inline-start: 32px;
		margin-top: -3px;
		z-index: 1;

		:deep(img.provider-icon.wide) {
			height: unset;
			min-width: unset;
			min-height: unset;
			border-radius: 4px;
		}
	}

	.extras {
		font-size: 13px;
		font-weight: bold;
		line-height: none;
		background-color: black;
		color: #c6c8cd;
		border-radius: 4px;
		width: 48px;
		aspect-ratio: 80/32;
		text-align: center;
		z-index: 0;
	}

	:first-child {
		margin-top: 0px;

		:deep(img.provider-icon.wide) {
			width: 56px;
		}

		& ~ picture {
			:deep(img.provider-icon.wide) {
				width: 48px;
			}
		}
	}

	:nth-child(odd) {
		margin-inline-start: 0px;
	}
}
</style>
